// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4847":"eca7f5310729c0b7","6909":"dbb3c60e52427937"}[chunkId] + ".css";
};